module.exports = watch

function watch(observable, listener) {
    var remove = observable(listener)
    listener(observable())
    return remove
}



//////////////////
// WEBPACK FOOTER
// ./~/observ/watch.js
// module id = 154
// module chunks = 0